import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { Panel } from "components/bootstrap";
import DocumentationLink from "components/support/DocumentationLink";
import DocsHelper from "util/DocsHelper";
export default function SidebarPermissions() {
  const { t } = useTranslation("integrations");
  return /* @__PURE__ */ React.createElement(Panel, { bsStyle: "info", header: /* @__PURE__ */ React.createElement("span", null, t("aws_sidebar_permissions.title")) }, /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "aws_sidebar_permissions.description",
      components: {
        docsLink: /* @__PURE__ */ React.createElement(
          DocumentationLink,
          {
            page: DocsHelper.PAGES.AWS_KINESIS_CLOUDWATCH_INPUT,
            text: t("aws_sidebar_permissions.docs_link_text")
          }
        )
      }
    }
  )));
}
